import React from "react";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";
import { ImgController } from "../../Scripts/ImgController";
const Wrapper = styled.div`
  box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1),
    0px 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  .border-CK {
    border-bottom: 1px solid #1f2937;
  }
`;

const MostListCard = ({ datas, loaded, wrapperClass, responsiveClass }) => {
  const itemsList = datas.map((item) => {
    return (
      <div
        className="flex flex-row justify-between gap-4 items-center"
        key={item?.index}
      >
        <div className="h-8 w-8">
          <ImgController
            src={item?.song?.cover}
            className="h-8 w-8"
            imgClassName="rounded-md"
          />
        </div>
        <div className="flex flex-col flex-1 truncate">
          <h5 className="color-grey text-xs"># {item?.index}</h5>
          <h5 className="font-bold text-xs">{item?.song?.name}</h5>
        </div>
        <h5 className="text-xs font-semibold">{item?.count}</h5>
      </div>
    );
  });
  const listSkeleton = () => {
    const arr = [1, 2, 3, 4, 5];
    return arr.map((a) => {
      return (
        <div
          className="flex flex-row justify-between gap-4 items-center h-8"
          key={a}
        >
          <Skeleton height="32px" width="32px" />
          <div className="flex flex-col flex-1">
            <h5 className="color-grey text-xs"># </h5>
            <Skeleton width="100%" />
          </div>
          <div className="w-4">
            <Skeleton />
          </div>
        </div>
      );
    });
  };
  return (
    <Wrapper className={`p-6 flex flex-col ${wrapperClass}`}>
      <h5 className="text-sm font-bold pb-2 border-CK mb-3">
        Хамгийн их сонсогдсон
      </h5>
      <div
        className={`flex flex-col gap-y-6 justify-start flex-1 ${responsiveClass}`}
      >
        {loaded ? itemsList : listSkeleton()}
      </div>
    </Wrapper>
  );
};

export default MostListCard;
